<template>
  <el-input-digit
    v-model.number="newValue"
    :format="newFormat"
    :precision="newPrecision"
    :maxlength="maxlength"
    :allowedNegative="allowedNegative"
    :placeholder="placeholder"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AmountDigitInput",
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    precision: Number,
    maxlength: {
      type: Number,
      default: 10,
    },
    placeholder: {
      type: String,
      default: "",
    },
    allowedNegative: {
      type: Boolean,
      default: false,
    },
    format: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['amountDigit']),
    newPrecision() {
      return this.precision !== undefined ? this.precision : this.amountDigit;
    },
    newFormat() {
      if (this.format) {
        return (this.allowedNegative ? '#.' : '+#.') + Array(this.newPrecision).fill('#').join(''); // #.##
      }
      return false;
    },
    newValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  }, 
  methods: {},
};
</script>

<style lang="scss" scoped></style>
